//----------------------------------------- CLASS
interface Props {
    interval: number;
    callbacks: (() => void)[];
    start?: boolean;

}

export default class Timer {

    interval = 5000;
    events: (() => void)[] = [];
    handle: NodeJS.Timeout | null = null;
    disposed = false;
    //------ Constructor
    constructor(options: Props) {
        this.interval = options.interval || 5000;
        this.events = options.callbacks;
        this.handle = null;
        this.disposed = false;
        if (options.start) this.start();
    }

    //------ Start timer
    start = () => {
        this.disposed = false;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        const timer = function () {
            if (self.disposed) { // try not firing when the tab isn't focused instead of filling the buffer with lots of calls
                return;
            }
            try {
                for (const callback of [...self.events]) {
                    try {
                        callback();
                    } catch (error) {
                        console.error('Timer callback failed:', error);
                    }
                }
            } finally {
                if (!self.disposed) self.handle = setTimeout(timer, self.interval);
            }
        }
        this.handle = setTimeout(timer, this.interval);
    }

    subscribe = (callback: () => void) => {
        this.events.push(callback);
        if (this.events.length > 0 && !this.handle) this.start();
    }

    unsubscribe = (callback: () => void) => {
        const idx = this.events.indexOf(callback);
        if (idx === -1) return;
        this.events.splice(idx, 1);
        if (this.events.length === 0 && this.handle) this.stop();
    }

    stop = () => {
        this.disposed = true;
        if (this.handle) clearInterval(this.handle);
        this.handle = null;
    }

    reinit = (interval: number) => {

        this.stop();
        this.interval = interval;
        this.start();

    }
}